"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateCustomUrl = exports.logError = exports.handleApiError = exports.getValidationStatus = exports.getResourceRecord = exports.getIntegrationStatus = exports.getDomainName = exports.getCurrentUrlValue = exports.createDomainStatusPoller = exports.copyToClipboard = exports.ERROR_MESSAGES = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

/**
 * Community Settings Utilities
 * Consolidated utilities for domain management, polling, and common functions
 */
// =============================================================================
// DOMAIN UTILITIES
// =============================================================================

/**
 * Extract domain validation options from custom domain data (internal helper)
 */
var getDomainValidationOption = function getDomainValidationOption(customDomainData) {
  var _customDomainData$Dom, _customDomainData$Dom2;

  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return (_customDomainData$Dom = customDomainData === null || customDomainData === void 0 ? void 0 : (_customDomainData$Dom2 = customDomainData.DomainValidationOptions) === null || _customDomainData$Dom2 === void 0 ? void 0 : _customDomainData$Dom2[index]) !== null && _customDomainData$Dom !== void 0 ? _customDomainData$Dom : null;
};
/**
 * Get domain name from custom domain data
 */


var getDomainName = function getDomainName(customDomainData) {
  var _validationOption$Dom;

  var validationOption = getDomainValidationOption(customDomainData);
  return (_validationOption$Dom = validationOption === null || validationOption === void 0 ? void 0 : validationOption.DomainName) !== null && _validationOption$Dom !== void 0 ? _validationOption$Dom : null;
};
/**
 * Get resource record from custom domain data
 */


exports.getDomainName = getDomainName;

var getResourceRecord = function getResourceRecord(customDomainData) {
  var _validationOption$Res;

  var validationOption = getDomainValidationOption(customDomainData);
  return (_validationOption$Res = validationOption === null || validationOption === void 0 ? void 0 : validationOption.ResourceRecord) !== null && _validationOption$Res !== void 0 ? _validationOption$Res : null;
};
/**
 * Get validation status from custom domain data
 */


exports.getResourceRecord = getResourceRecord;

var getValidationStatus = function getValidationStatus(customDomainData) {
  var _validationOption$Val;

  var validationOption = getDomainValidationOption(customDomainData);
  return (_validationOption$Val = validationOption === null || validationOption === void 0 ? void 0 : validationOption.ValidationStatus) !== null && _validationOption$Val !== void 0 ? _validationOption$Val : null;
};
/**
 * Get integration status from custom domain data
 */


exports.getValidationStatus = getValidationStatus;

var getIntegrationStatus = function getIntegrationStatus(customDomainData) {
  var _customDomainData$Int;

  return (_customDomainData$Int = customDomainData === null || customDomainData === void 0 ? void 0 : customDomainData.IntegrationStatus) !== null && _customDomainData$Int !== void 0 ? _customDomainData$Int : null;
};
/**
 * Get current URL value (prioritizes user input over API data)
 */


exports.getIntegrationStatus = getIntegrationStatus;

var getCurrentUrlValue = function getCurrentUrlValue(customURL, customDomainData) {
  var domainName = getDomainName(customDomainData);
  return customURL || (domainName !== null && domainName !== void 0 ? domainName : '');
}; // =============================================================================
// POLLING UTILITIES
// =============================================================================


exports.getCurrentUrlValue = getCurrentUrlValue;

var createDomainStatusPoller = function createDomainStatusPoller(options) {
  var fetchStatus = options.fetchStatus,
      shouldStop = options.shouldStop,
      onData = options.onData,
      onError = options.onError,
      _options$intervalMs = options.intervalMs,
      intervalMs = _options$intervalMs === void 0 ? 5000 : _options$intervalMs;
  var intervalId = null;
  var running = false;

  var stop = function stop() {
    if (intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    }

    running = false;
  };

  var tick = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _data;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchStatus();

            case 3:
              _data = _context.sent;
              if (onData) onData(_data);

              if (shouldStop(_data)) {
                stop();
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              if (onError) onError(_context.t0); // keep polling on error

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function tick() {
      return _ref.apply(this, arguments);
    };
  }();

  var start = function start() {
    if (running) return;
    running = true; // run once immediately

    void tick(); // then poll

    intervalId = window.setInterval(tick, intervalMs);
  };

  var isRunning = function isRunning() {
    return running;
  };

  return {
    start: start,
    stop: stop,
    isRunning: isRunning
  };
}; // =============================================================================
// COMMON UTILITIES
// =============================================================================

/**
 * Log error with context information
 * @deprecated Use developerExperienceService.logError instead or console.error directly
 */


exports.createDomainStatusPoller = createDomainStatusPoller;

var logError = function logError(context, error) {
  console.error("Error in ".concat(context, ":"), error);
};
/**
 * Extract error message from API error response
 */


exports.logError = logError;

var handleApiError = function handleApiError(error, fallbackMessage) {
  var _error$response, _error$response$data;

  if (error !== null && error !== void 0 && (_error$response = error.response) !== null && _error$response !== void 0 && (_error$response$data = _error$response.data) !== null && _error$response$data !== void 0 && _error$response$data.message) {
    return error.response.data.message;
  }

  if (error !== null && error !== void 0 && error.message) {
    return error.message;
  }

  return fallbackMessage;
};

exports.handleApiError = handleApiError;

var copyToClipboard = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(text) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return navigator.clipboard.writeText(text);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function copyToClipboard(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Error messages used across components
 */


exports.copyToClipboard = copyToClipboard;
var ERROR_MESSAGES = {
  INVALID_URL: 'Please enter a valid URL (e.g., community.example.com)',
  REQUIRED_FIELD: 'Please enter a valid URL',
  VALIDATION_FAILED: 'URL validation failed. Please check the URL and try again.',
  FETCH_FAILED: 'Failed to fetch custom domain information',
  SAVE_FAILED: 'Failed to save destination URL'
}; // =============================================================================
// VALIDATION UTILITIES
// =============================================================================

/**
 * Validates the custom URL input
 */

exports.ERROR_MESSAGES = ERROR_MESSAGES;

var validateCustomUrl = function validateCustomUrl(url) {
  if (!url.trim()) {
    return ERROR_MESSAGES.REQUIRED_FIELD;
  }

  return null;
};

exports.validateCustomUrl = validateCustomUrl;